import React from "react";
import authUtil from "utils/auth";

export default () => {
  authUtil.login();
  return <div> Redirect ... </div>;
};



// WEBPACK FOOTER //
// ./src/pages/Login/index.js